var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAni12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46974 0.219737C4.61038 0.079134 4.80111 0.000147343 4.99999 0.000147343C5.19886 0.000147343 5.38959 0.079134 5.53024 0.219737L9.77299 4.46249C9.84462 4.53167 9.90176 4.61443 9.94106 4.70593C9.98037 4.79744 10.0011 4.89585 10.0019 4.99544C10.0028 5.09502 9.98381 5.19378 9.9461 5.28595C9.90839 5.37812 9.8527 5.46186 9.78228 5.53228C9.71186 5.6027 9.62812 5.65839 9.53595 5.6961C9.44378 5.73381 9.34502 5.75279 9.24544 5.75192C9.14585 5.75106 9.04744 5.73037 8.95593 5.69106C8.86443 5.65176 8.78167 5.59462 8.71249 5.52299L4.99999 1.81049L1.28749 5.52299C1.14603 5.65961 0.956584 5.7352 0.759936 5.73349C0.563289 5.73178 0.375179 5.65291 0.236123 5.51385C0.0970669 5.3748 0.0181894 5.18669 0.0164814 4.99004C0.0147724 4.79339 0.0903683 4.60394 0.226986 4.46249L4.46974 0.219737Z",
    fill: "#FFFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni12);
export default __webpack_public_path__ + "static/media/Ani12.9e6919800077afdc7ef9c6ab9d3c3e3d.svg";
export { ForwardRef as ReactComponent };